import { combineReducers } from 'redux';
import core from './core';
import main from './main';

export default combineReducers({
  core,
  main,
});
